import {fadeIn, fadeOut} from './fade';

//イントロ
export default function () {
	const isVisited = localStorage.getItem("isVisited");
	//次回から表示しないをチェックすると 9 が入る
	if(isVisited != '10') {
		new Splide( '.js-intro-splide').mount();

		const introEl = document.getElementById('js-intro');
		const isHidden = document.getElementById('js-intro-hidden');
		const closeBtns = document.querySelectorAll('.js-intro-close');
		const nextBtns = document.querySelectorAll('.js-intro-next');

		introEl.addEventListener('touchmove', function(e) {
			e.preventDefault();
		});
    [].forEach.call(nextBtns, btn => {
			btn.addEventListener('click', function(e) {
				e.preventDefault();
				introEl.classList.add('is-next');
			});
    });
    [].forEach.call(closeBtns, btn => {
			btn.addEventListener('click', function(e) {
				e.preventDefault();
				if(isHidden.checked) {
					localStorage.setItem('isVisited', '10');
				} else {
					localStorage.setItem('isVisited', '');
				}
				fadeOut(null, introEl);
			});
    });

		introEl.style.display = 'block';
		trigger(window, 'loadingEnd');

		setTimeout(function() {
			introEl.classList.add('is-show');
		},800);

	}
}
